import type { FlashcardReviewCard } from "@learn-flow/contracts";

export function shuffledCopy<T>(source: readonly T[], random: () => number = Math.random): T[] {
  const result = [...source];
  for (let index = result.length - 1; index > 0; index -= 1) {
    const swapIndex = Math.floor(random() * (index + 1));
    const current = result[index];
    const swap = result[swapIndex];
    if (current === undefined || swap === undefined) continue;
    result[index] = swap;
    result[swapIndex] = current;
  }
  return result;
}

export function createReviewSnapshot(
  cards: readonly FlashcardReviewCard[],
  collectionId: string | null,
  random: () => number = Math.random,
): FlashcardReviewCard[] {
  return shuffledCopy(
    cards.filter((card) => card.collectionId === collectionId),
    random,
  );
}
